import { Form, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts"; 

const DisbursementPieChart = ({ formData, setFormData }) => {
  const dispatch = useDispatch();
  const url = "api/v2/dashboard/fetch-dashboard";
  const urlCat = "api/v1/payments/fetch-payment-categories";
  const { loading, data, dataCat } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    dataCat: state.fetch.data[urlCat] || [],
  }));
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const handleValuesChange = async (value) => {
    setFormData((prev) => ({
      ...prev,
      selectSubCat: value,
    }));
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const { subCategory, amount, color } = payload[0].payload;
      return (
        <div className="p-2 rounded-md shadow-md bg-white border border-gray-200">
          <div className="flex items-center gap-2">
            <span className="w-3 h-3  " style={{ backgroundColor: color }} />
            <span className="font-medium">{subCategory}</span>
          </div>
          <div className="text-sm text-gray-600">
            KSh {amount.toLocaleString()}
          </div>
        </div>
      );
    }
    return null;
  };

 useEffect(() => {
  if (dataCat?.length > 0 && !formData?.selectSubCat) {
    setFormData((prev) => ({
      ...prev,
      selectSubCat: dataCat[0].pcId, 
    }));
  }
}, [dataCat, formData?.selectSubCat, setFormData]);

  return (
    <div className="rounded-[.75rem] bg-white p-[1.25rem] w-full">
      <div className="flex lg:flex-row flex-col lg:items-center items-start lg:justify-between">
        <div className="ndovu-gradient-title text-[1rem] font-[400] leading-6 font-lexendS ">
          Top 5 Disbursement Subcategories
        </div>
        <div className="lg:w-[30%] w-full">
          <Select
            className="banner-selector banner-arrow"
            allowClear
            style={{
              width: "100%",
            }}
            options={dataCat?.map((item) => ({
              value: item?.pcId,
              label: item?.pcName,
            }))}
            value={formData?.selectSubCat}
            onChange={(value) => handleValuesChange(value)}
            placeholder="Select"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <PieChart>
          <Pie
            data={data?.top5DisbursementPerSubCategory}
            cx="50%"
            cy="50%"
            labelLine={false}
            outerRadius={100}
            dataKey="amount"
            nameKey="subCategory"
          >
            {data?.top5DisbursementPerSubCategory?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DisbursementPieChart;
